import { API_ENDPOINTS } from "../../config/api";

function authHeaders() {
  return {
    Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
    "Content-Type": "application/json",
  };
}

async function readJson(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const error = new Error(data.message || "Request failed");
    error.status = res.status;
    throw error;
  }
  return data;
}

export function listFlowDiagrams() {
  return fetch(API_ENDPOINTS.FLOW_DIAGRAMS, { headers: authHeaders() }).then(readJson);
}

export function getFlowDiagram(id) {
  return fetch(`${API_ENDPOINTS.FLOW_DIAGRAMS}/${id}`, { headers: authHeaders() }).then(readJson);
}

export function createFlowDiagram(payload) {
  return fetch(API_ENDPOINTS.FLOW_DIAGRAMS, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  }).then(readJson);
}

export function updateFlowDiagram(id, payload) {
  return fetch(`${API_ENDPOINTS.FLOW_DIAGRAMS}/${id}`, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  }).then(readJson);
}

export function deleteFlowDiagram(id) {
  return fetch(`${API_ENDPOINTS.FLOW_DIAGRAMS}/${id}`, {
    method: "DELETE",
    headers: authHeaders(),
  }).then(readJson);
}
